// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LvatFQrUE7gurM {\n  text-align: center;\n  margin-bottom: 12px;\n}\n.rDpOxTWtVgEb7_ {\n  margin-bottom: 0;\n}\n.XaeFbf9r7bH8Rb {\n  flex: 1 1 auto;\n  z-index: 1;\n  min-height: 0;\n  padding-top: 1px;\n}\n.aBddjoGRRChHhl {\n  display: flex;\n}\n.JAe5tEBiKGdjZ2 {\n  width: 100%;\n  margin-bottom: 8px;\n  min-height: 56px;\n}\n.K9ng24WUvwHe1n,\n.wn4p9CSHSL2BEq {\n  margin-top: 8px;\n  margin-bottom: 0;\n}\n._PMMwPY4FfJvtJ {\n  text-decoration: none;\n}\n.mxsnFdAGimkdpq {\n  display: flex;\n  flex-direction: column;\n  margin-left: 8px;\n}\n.mxsnFdAGimkdpq .k257AN1RMJ9eha {\n  width: 32px;\n  padding: 6px 8px;\n  margin-bottom: 8px;\n}\n.mxsnFdAGimkdpq .k257AN1RMJ9eha:focus {\n  outline: -webkit-focus-ring-color auto 1px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emptyStateMessage": "LvatFQrUE7gurM",
	"createNewTemplateButton": "rDpOxTWtVgEb7_",
	"templateCards": "XaeFbf9r7bH8Rb",
	"templateCardContainer": "aBddjoGRRChHhl",
	"templateCard": "JAe5tEBiKGdjZ2",
	"editTemplatesButton": "K9ng24WUvwHe1n",
	"finishEditingButton": "wn4p9CSHSL2BEq",
	"noTextDecoration": "_PMMwPY4FfJvtJ",
	"controlButtons": "mxsnFdAGimkdpq",
	"controlButton": "k257AN1RMJ9eha"
};
export default ___CSS_LOADER_EXPORT___;
